<template>
  <v-card
    rounded
    max-width="400"
    color="grey lighten-4"
  >
    <v-card-text>
      <h1 class="text-center grey--text text--darken-1">
        <v-icon
          x-large
          class="primary--text text--lighten-1"
        >
          {{ !isTodaySchedule ? 'mdi-timeline-check' : 'mdi-information'}}
        </v-icon>
        {{ !isTodaySchedule ? 'No schedules for today' : 'No case selected'}}
      </h1>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'NoCaseSelected',

    props: {
      isTodaySchedule: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>